var Backbone = require('backbone');
var Index = require('availability/pages/Index/Index');

module.exports = Backbone.Router.extend({

    routes: {
        '': 'index'
    },


    index: function () {
        new Index({
            router: this
        });
    },


    start: function () {
        //If you'd like to use pushState, but have browsers that don't support it natively
        //use full page refreshes instead, you can add {hashChange: false} to the options.
        //for ie 9 mainly
        Backbone.history.start({
            pushState: true,
            hashChange: false,
            silent: false
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/availability/Router.js
// module id = 6
// module chunks = 0